import get from 'lodash/get';
import { InMemoryCache } from 'apollo-cache-inmemory';
import { ApolloClient } from 'apollo-client';
import { ApolloLink } from 'apollo-link';
import { onError } from 'apollo-link-error';
import { HttpLink } from 'apollo-link-http';
import { RetryLink } from 'apollo-link-retry';
import { fragmentCacheRedirect, fragmentLinkState } from 'apollo-link-state-fragment';
import log from '@atlassian/jira-common-util-logging/src/log.tsx';
import { UFOLoggerLink } from '@atlassian/ufo-apollo-log/link';

const APOLLO_CLIENT_ID = 'GATEWAY';
const CACHE_NAME = `apollo-cache/${APOLLO_CLIENT_ID}`;
const LOG_NAMESPACE = `apollo.${APOLLO_CLIENT_ID}.error.graphql`;

// eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
const isSsrSuccessful = () => (__SERVER__ ? true : !window || !window.SPA_STATE);
const NETWORK_ERRORS_COUNTER_KEY = 'networkErrorsCounter';

const retryLink = new RetryLink({
	delay: {
		initial: 5000,
		max: 5000,
	},
	attempts: {
		max: 2,
		retryIf: (networkError) => networkError && !networkError.statusCode,
	},
});

const errorLink = onError(({ graphQLErrors, networkError, operation }) => {
	if (graphQLErrors)
		if (Array.isArray(graphQLErrors)) {
			graphQLErrors.map(({ message, locations, path }) =>
				log.safeErrorWithoutCustomerData(
					LOG_NAMESPACE,
					`[GraphQL error]: Message: ${message}, Location: ${locations}, Path: ${path}`,
					{
						message: JSON.stringify(message),
						path: JSON.stringify(path),
						locations: JSON.stringify(locations),
					},
				),
			);
		} else {
			log.safeErrorWithoutCustomerData(
				LOG_NAMESPACE,
				'[GraphQL error]: Unexpected error message format',
				{
					message: JSON.stringify(graphQLErrors),
				},
			);
		}

	if (networkError) {
		const occuredNetworkErrorsBefore = get(operation.getContext(), [NETWORK_ERRORS_COUNTER_KEY], 0);
		log.safeErrorWithoutCustomerData(
			LOG_NAMESPACE,
			`[Network error]: ${networkError}, attempt ${occuredNetworkErrorsBefore + 1}`,
		);
		operation.setContext({
			[NETWORK_ERRORS_COUNTER_KEY]: occuredNetworkErrorsBefore + 1,
		});
	}
});

const cache = new InMemoryCache({
	cacheRedirects: {
		Query: {
			...fragmentCacheRedirect(),
		},
	},
	dataIdFromObject: (object) => object.id,
})
	// eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
	.restore((!isSsrSuccessful() && window.SPA_STATE[CACHE_NAME]) || {});

export const clientCreator = () => {
	const uri = '/gateway/api/graphql';

	const link = ApolloLink.from([
		retryLink,
		errorLink,
		UFOLoggerLink,
		fragmentLinkState(cache),
		new HttpLink({
			uri,
			credentials: 'same-origin',
		}),
	]);

	return new ApolloClient({
		name: APOLLO_CLIENT_ID,
		ssrMode: isSsrSuccessful(),
		// @ts-expect-error - TS2345 - Argument of type '{ name: string; ssrMode: boolean; addTypename: boolean; link: ApolloLink; cache: InMemoryCache; connectToDevTools: boolean; }' is not assignable to parameter of type 'ApolloClientOptions<NormalizedCacheObject>'.
		addTypename: true,
		link,
		cache,
		connectToDevTools: process.env.NODE_ENV === 'development',
	});
};
